import React, { useState } from 'react';
import './UserTable.css';

const usersData = [
  { id: 1, name: 'Aaron Miles', email: 'aaron@geektrust.in', role: 'Member' },
  { id: 2, name: 'Aishwarya Naik', email: 'aishwarya@geektrust.in', role: 'Member' },
  { id: 3, name: 'Arvind Kumar', email: 'arvind@geektrust.in', role: 'Admin' },
  { id: 4, name: 'Caterina Bincto', email: 'caterina@geektrust.in', role: 'Member' },
  { id: 5, name: 'Chetan Kumar', email: 'chetan@geektrust.in', role: 'Member' },
  { id: 6, name: 'Jim McClain', email: 'jim@geektrust.in', role: 'Member' },
  { id: 7, name: 'Mahaveer Singh', email: 'mahaveer@geektrust.in', role: 'Member' },
  { id: 8, name: 'Rahul Jain', email: 'rahul@geektrust.in', role: 'Admin' },
  { id: 9, name: 'Rizan Khan', email: 'rizan@geektrust.in', role: 'Member' },
  { id: 10, name: 'Sarah Potter', email: 'sarah@geektrust.in', role: 'Admin' },
];

const UserTable = () => {
  const [users, setUsers] = useState(usersData);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;

  const handleDelete = (userId) => {
    setUsers(users.filter(user => user.id !== userId));
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = users.filter(user =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
    user.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredUsers.length / usersPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="user-table-container">
      <input
        type="text"
        placeholder="Search by name, email or role"
        value={searchTerm}
        onChange={handleSearch}
        className="search-input"
      />
      <table className="user-table">
        <thead>
          <tr>
            <th><input type="checkbox" /></th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentUsers.map(user => (
            <tr key={user.id}>
              <td><input type="checkbox" /></td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.role}</td>
              <td>
                <button className="edit-button">✏️</button>
                <button className="delete-button" onClick={() => handleDelete(user.id)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pagination">
        <button onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>«</button>
        {pageNumbers.map(number => (
          <button key={number} onClick={() => setCurrentPage(number)} className={currentPage === number ? 'active' : ''}>
            {number}
          </button>
        ))}
        <button onClick={() => setCurrentPage(prev => Math.min(prev + 1, pageNumbers.length))}>»</button>
      </div>
      <button className="delete-selected-button">Delete Selected</button>
    </div>
  );
};

export default UserTable;
